/* eslint-disable import/prefer-default-export */
export const tryParse = data => {
  try {
    return JSON.parse(data);
  } catch {
    return data;
  }
};
/* eslint-enable import/prefer-default-export */
